import { ILead } from "../models/Lead";
import { vehicleDisplayIdentifier } from "./vehicleIdentifier";

/**
 * Leads booked without a price are stored at 0, and their collection note prints "PRICE NOT SET".
 * Lists them by registration so the office hears about it before the notes go out with a driver.
 *
 * Only meaningful for someone who can see prices: for everyone else the API blanks the figure to 0
 * on every lead, so callers skip the check rather than flag the whole day.
 */
export const unpricedLeadLabels = (leads: Pick<ILead, "price" | "vehicle">[] | undefined): string[] =>
  (leads ?? [])
    .filter((lead) => !((lead.price ?? 0) > 0))
    .map((lead) => vehicleDisplayIdentifier(lead.vehicle) ?? "Unknown vehicle");
